module.exports = __webpack_public_path__ + "img/rencaituijian.53c93ae8.png";